/* eslint-disable prettier/prettier */ 'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BUSINESS_BOOKER_USER_ROLES } from '@whitbread-eos/api';
import { Drawer, DrawerContent, DrawerTitle, DrawerDescription } from '@whitbread-eos/atoms/ui';
import { formatIBAssetsUrl } from '@whitbread-eos/utils/server';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import FirstLevelNav from '../FirstLevelNav';
import SecondLevelNav from '../SecondLevelNav';
import ThirdLevelNavMobile from '../ThirdLevelNavMobile';
const SidebarMobile = ({ userRole, menuLabels, icons, isAccountHolder })=>{
    const baseDataTestId = 'SidebarMobile';
    const pathname = usePathname();
    const [isSecondLevelOpen, setIsSecondLevelOpen] = useState(false);
    const handleSecondLevelToggle = ()=>{
        setIsSecondLevelOpen(!isSecondLevelOpen);
    };
    const hasThirdLevel = ()=>{
        const thirdLevelPaths = [
            'manage/employees',
            'manage/cards'
        ];
        return thirdLevelPaths.some((path)=>pathname.includes(path));
    };
    return /*#__PURE__*/ _jsxs("nav", {
        "data-testid": `${baseDataTestId}-container`,
        className: `${containerBaseStyle} ${hasThirdLevel() ? expandedStyle : ''}`,
        children: [
            /*#__PURE__*/ _jsx(Drawer, {
                open: isSecondLevelOpen,
                onOpenChange: setIsSecondLevelOpen,
                children: /*#__PURE__*/ _jsxs(DrawerContent, {
                    hasCloseButton: false,
                    className: 'p-0 mt-0',
                    children: [
                        /*#__PURE__*/ _jsx(DrawerTitle, {
                            className: drawerTitleStyle,
                            children: 'Navigation Menu'
                        }),
                        /*#__PURE__*/ _jsx(DrawerDescription, {
                            className: drawerTitleStyle,
                            children: 'Navigation Menu'
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: secondLevelDrawerStyle,
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    className: secondLevelToggleStyle,
                                    onClick: ()=>handleSecondLevelToggle(),
                                    "data-testid": "Second-Level-Collapse-Icon",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        alt: "collapse second level icon",
                                        src: formatIBAssetsUrl(icons['icon.chevron.down.purple']),
                                        width: 24,
                                        height: 24
                                    })
                                }),
                                /*#__PURE__*/ _jsx(SecondLevelNav, {
                                    isTravelManager: userRole === BUSINESS_BOOKER_USER_ROLES.SUPER,
                                    isAccountHolder: isAccountHolder,
                                    onLinkClick: handleSecondLevelToggle
                                })
                            ]
                        })
                    ]
                })
            }),
            hasThirdLevel() && /*#__PURE__*/ _jsx(ThirdLevelNavMobile, {
                icons: icons,
                toggleSecondLevel: handleSecondLevelToggle
            }),
            /*#__PURE__*/ _jsx(FirstLevelNav, {
                menuLabels: menuLabels,
                userRole: userRole,
                isAccountHolder: isAccountHolder,
                isMobile: true,
                onManageClick: handleSecondLevelToggle
            })
        ]
    });
};
export default SidebarMobile;
const containerBaseStyle = 'fixed bottom-0 left-0 hidden mobile:flex flex-col w-full max-h-mobileSidebarHeight border-t border-lightGrey3 bg-baseWhite z-30 px-4 py-2 mobile:min-w-[23.4rem]';
const expandedStyle = 'rounded-t-lg';
const secondLevelDrawerStyle = 'px-4 pb-6 pt-20';
const secondLevelToggleStyle = 'absolute right-6 top-4 flex justify-center items-center w-8 h-8 rounded-full border border-lightGrey3 bg-baseWhite cursor-pointer hover:bg-lightGrey4 active:bg-toggleButtonPressed';
const drawerTitleStyle = 'hidden';
